import { togaApiRequest } from "../../../api/toga";
import { ExtendedOptionsType } from "../../Items/api/itemsApi";

export async function getShipments(internalId: string, isFulfilled?: boolean) {
	let options: ExtendedOptionsType = {
		fields: [
			"uuid",
			"itemFulfillmentPackages.trackingNumber.description",
			"itemFulfillmentPackages.trackingNumber.containsBattery",
			"itemFulfillmentPackages.trackingNumber.requiresSignature",
			"itemFulfillmentPackages.trackingNumber.weight",
			"itemFulfillmentPackages.trackingNumber.length",
			"itemFulfillmentPackages.trackingNumber.height",
			"itemFulfillmentPackages.trackingNumber.width",
			"itemFulfillmentPackages.trackingNumber.uuid",
			"itemFulfillmentPackages.trackingNumber.shippingCarrier.name",
			"itemFulfillmentPackages.trackingNumber.shippingCarrier.urlLogo",
			"itemFulfillmentPackages.trackingNumber.shippingMethod.name",
			"itemFulfillmentPackages.trackingNumber.shippingCarrierAccountNumber.accountNumber",
			"itemFulfillmentPackages.uuid",
			"shipToAddress.addressee",
			"shipToAddress.attention",
			"shipToAddress.line1",
			"shipToAddress.line2",
			"shipToAddress.city",
			"shipToAddress.zip",
			"shipToAddress.phoneNumber",
			"shipToAddress.state.name",
			"shipToAddress.state.code",
			"shipToAddress.state.country.name",
			"shipToAddress.state.country.code",
			"itemFulfillmentItems.quantity",
			"itemFulfillmentItems.uuid",
		],
		join: [
			{
				SalesOrders: {
					"ItemFulfillments.salesOrderId": "SalesOrders.id",
				},
			},
		],
		depth: 4,
		where: {
			and: [
				{
					"SalesOrders.c_netsuiteInternalSalesOrderId": {
						"=": internalId,
					},
				},
				{
					"ItemFulfillments.dtSubmitted": isFulfilled
						? { ne: null }
						: { eq: null },
				},
			],
		},
	};

	let response = await togaApiRequest(
		"GET",
		"/item-fulfillments",
		null,
		options
	);

	if (!response.isSuccess) {
 		return;
	}
	return response.data;
}

export async function deleteShipments(
	shipmentUuid: string,
	itemFulfillmentPackageUuid?: string,
	trackingNumberUuid?: string
) {
	let response;

	if (itemFulfillmentPackageUuid) {
		response = await togaApiRequest(
			"DELETE",
			"/item-fulfillment-packages/" + itemFulfillmentPackageUuid
		);
	}

	if (trackingNumberUuid) {
		response = await togaApiRequest(
			"DELETE",
			"/tracking-numbers/" + trackingNumberUuid
		);
	}

	//Get Item Fulfillment Items.
	let options: ExtendedOptionsType = {
		fields: [
			"itemFulfillmentItems.uuid",
			"itemFulfillmentItems.itemFulfillmentItemUnits.uuid",
		],
	};
	response = await togaApiRequest(
		"GET",
		"/item-fulfillments/" + shipmentUuid,
		null,
		options
	);
	const itemsUuids = response.data.itemFulfillments.itemFulfillmentItems.map(
		// @ts-ignore

		(item) => item.uuid
	);

	const itemFulfillmentItemUnitsUuids =
		// @ts-ignore

		response.data.itemFulfillments.itemFulfillmentItems.flatMap((item) =>
			// @ts-ignore
			item.itemFulfillmentItemUnits.map((unit) => unit.uuid)
		);

	//Delete All the Item Fulfillment Item Units.
	for (const uuid of itemFulfillmentItemUnitsUuids) {
		try {
			const response = await togaApiRequest(
				"DELETE",
				"/item-fulfillment-item-units/" + uuid
			);
		} catch (error) {
			console.error(`Error deleting item with UUID ${uuid}:`, error);
		}
	}

	for (const uuid of itemsUuids) {
		try {
			const response = await togaApiRequest(
				"DELETE",
				"/item-fulfillment-items/" + uuid
			);
		} catch (error) {
			console.error(`Error deleting item with UUID ${uuid}:`, error);
		}
	}

	response = await togaApiRequest(
		"DELETE",
		"/item-fulfillments/" + shipmentUuid
	);

	return response;
}

/**
 * Downloads an invoice PDF by its UUID.
 *
 * @param invoiceUuid The UUID of the invoice to download.
 */

function base64ToArrayBuffer(base64: string) {
	const binaryString = atob(base64);
	const len = binaryString.length;
	const bytes = new Uint8Array(len);
	for (let i = 0; i < len; i++) {
		bytes[i] = binaryString.charCodeAt(i);
	}
	return bytes.buffer;
}

export async function handleReprintPdf(trackingNumberUuid: any) {
	//Get the tracking number and base64 pdf from the shipment
	let response = await togaApiRequest(
		"GET",
		"/tracking-numbers/" + trackingNumberUuid
	);
	if (!response.isSuccess) {
		return response;
	}

	try {
		// Step 1: Get the base64 encoded PDF string
		const base64Data = response.data.trackingNumbers.labelPdfFile;
		const base64String = base64Data.replace(
			/^data:application\/pdf;base64,/,
			""
		);
		const arrayBuffer = base64ToArrayBuffer(base64String);

		const blob = new Blob([arrayBuffer], {
			type: "application/pdf",
		});

		const pdfUrl = URL.createObjectURL(blob);

		const link = document.createElement("a");
		link.href = pdfUrl;
		link.download = `TrackingNumbers${response.data.trackingNumbers.number}.pdf`;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		// Clean up the URL after initiating download
		URL.revokeObjectURL(pdfUrl);
		return response;
	} catch (error) {
		return response;
	}
}
